import "./Home2.module.css";
import Header from "@/reusable_sections/Header";
import Herobanner from "./sections/Herobanner";
import Features from "./sections/Features";
import Footer from "@/reusable_sections/Footer";
export default function Home2Page() {
  return <div>
      <Header />
      <Herobanner />
      <Features />
      <Footer />
    </div>;
}